var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c(
        "base-modal-ex",
        {
          attrs: {
            active: _vm.isActive,
            "animation-in": _vm.animationIn,
            "animation-out": _vm.animationOut,
            "animation-duration": _vm.animationDuration,
            "can-cancel": false,
            "min-width": 50,
            "min-height": 50,
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isActive = $event
            },
          },
        },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c(
              "p",
              {
                staticClass: "modal-card-title",
                class: { "is-flex-items-center": _vm.showIcon },
              },
              [
                _vm.showIcon
                  ? _c(
                      "span",
                      {
                        staticClass: "icon is-medium",
                        class: `has-text-${_vm.iconType}`,
                        staticStyle: { "margin-right": "0.5rem" },
                      },
                      [
                        _c("i", {
                          staticClass: "mdi mdi-36px",
                          class: `${_vm.iconName}`,
                        }),
                      ]
                    )
                  : _vm._e(),
                _c("span", [_vm._v("Edit Default Options")]),
              ]
            ),
          ]),
          _c("section", { staticClass: "modal-card-body" }, [
            _c("div", { staticClass: "tile is-ancestor is-parent" }, [
              _c("div", { staticClass: "tile" }, [
                _c("div", { staticClass: "tile is-parent is-half" }, [
                  _c("article", { staticClass: "tile is-child box" }, [
                    _c("div", { staticClass: "columns is-gapless" }, [
                      _c("div", { staticClass: "column" }, [
                        _c("div", { staticClass: "field" }, [
                          _c("label", { staticClass: "label mb-4" }, [
                            _vm._v("Quote Information"),
                          ]),
                          _c("div", { staticClass: "field-body" }, [
                            _c("div", { staticClass: "field" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pretty p-icon p-curve p-smooth p-bigger",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.defaultSetting.isSendClaimNo,
                                        expression:
                                          "defaultSetting.isSendClaimNo",
                                      },
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.defaultSetting.isSendClaimNo
                                      )
                                        ? _vm._i(
                                            _vm.defaultSetting.isSendClaimNo,
                                            null
                                          ) > -1
                                        : _vm.defaultSetting.isSendClaimNo,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a =
                                            _vm.defaultSetting.isSendClaimNo,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.defaultSetting,
                                                "isSendClaimNo",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.defaultSetting,
                                                "isSendClaimNo",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.defaultSetting,
                                            "isSendClaimNo",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _c("div", { staticClass: "state" }, [
                                    _c("i", {
                                      staticClass: "icon mdi mdi-check",
                                    }),
                                    _c("label", [_vm._v("Send Claim No.")]),
                                  ]),
                                ]
                              ),
                            ]),
                            _c("div", { staticClass: "field" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pretty p-icon p-curve p-smooth p-bigger",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.defaultSetting.isSendPartNo,
                                        expression:
                                          "defaultSetting.isSendPartNo",
                                      },
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.defaultSetting.isSendPartNo
                                      )
                                        ? _vm._i(
                                            _vm.defaultSetting.isSendPartNo,
                                            null
                                          ) > -1
                                        : _vm.defaultSetting.isSendPartNo,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a =
                                            _vm.defaultSetting.isSendPartNo,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.defaultSetting,
                                                "isSendPartNo",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.defaultSetting,
                                                "isSendPartNo",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.defaultSetting,
                                            "isSendPartNo",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _c("div", { staticClass: "state" }, [
                                    _c("i", {
                                      staticClass: "icon mdi mdi-check",
                                    }),
                                    _c("label", [_vm._v("Send Part No.")]),
                                  ]),
                                ]
                              ),
                            ]),
                            _c("div", { staticClass: "field" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pretty p-icon p-curve p-smooth p-bigger",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.defaultSetting.isSendPartNotes,
                                        expression:
                                          "defaultSetting.isSendPartNotes",
                                      },
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.defaultSetting.isSendPartNotes
                                      )
                                        ? _vm._i(
                                            _vm.defaultSetting.isSendPartNotes,
                                            null
                                          ) > -1
                                        : _vm.defaultSetting.isSendPartNotes,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a =
                                            _vm.defaultSetting.isSendPartNotes,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.defaultSetting,
                                                "isSendPartNotes",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.defaultSetting,
                                                "isSendPartNotes",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.defaultSetting,
                                            "isSendPartNotes",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _c("div", { staticClass: "state" }, [
                                    _c("i", {
                                      staticClass: "icon mdi mdi-check",
                                    }),
                                    _c("label", [_vm._v("Send Part Notes")]),
                                  ]),
                                ]
                              ),
                            ]),
                            _c("div", { staticClass: "field" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pretty p-icon p-curve p-smooth p-bigger",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.defaultSetting.isAutoSelectPhotos,
                                        expression:
                                          "defaultSetting.isAutoSelectPhotos",
                                      },
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.defaultSetting.isAutoSelectPhotos
                                      )
                                        ? _vm._i(
                                            _vm.defaultSetting
                                              .isAutoSelectPhotos,
                                            null
                                          ) > -1
                                        : _vm.defaultSetting.isAutoSelectPhotos,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a =
                                            _vm.defaultSetting
                                              .isAutoSelectPhotos,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.defaultSetting,
                                                "isAutoSelectPhotos",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.defaultSetting,
                                                "isAutoSelectPhotos",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.defaultSetting,
                                            "isAutoSelectPhotos",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _c("div", { staticClass: "state" }, [
                                    _c("i", {
                                      staticClass: "icon mdi mdi-check",
                                    }),
                                    _c("label", [_vm._v("Auto Select Photos")]),
                                  ]),
                                ]
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "is-divider" }),
                        ]),
                        _c("div", { staticClass: "field" }, [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("Select Default Item Type"),
                          ]),
                          _c("div", { staticClass: "field-body" }, [
                            _c("div", { staticClass: "field" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pretty p-icon p-curve p-smooth p-bigger",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.defaultSetting
                                            .isSelectItemTypeOEM,
                                        expression:
                                          "defaultSetting.isSelectItemTypeOEM",
                                      },
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.defaultSetting.isSelectItemTypeOEM
                                      )
                                        ? _vm._i(
                                            _vm.defaultSetting
                                              .isSelectItemTypeOEM,
                                            null
                                          ) > -1
                                        : _vm.defaultSetting
                                            .isSelectItemTypeOEM,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a =
                                            _vm.defaultSetting
                                              .isSelectItemTypeOEM,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.defaultSetting,
                                                "isSelectItemTypeOEM",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.defaultSetting,
                                                "isSelectItemTypeOEM",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.defaultSetting,
                                            "isSelectItemTypeOEM",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _c("div", { staticClass: "state" }, [
                                    _c("i", {
                                      staticClass: "icon mdi mdi-check",
                                    }),
                                    _c("label", [_vm._v("OEM")]),
                                  ]),
                                ]
                              ),
                            ]),
                            _c("div", { staticClass: "field" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pretty p-icon p-curve p-smooth p-bigger",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.defaultSetting
                                            .isSelectItemTypeAfterMarket,
                                        expression:
                                          "defaultSetting.isSelectItemTypeAfterMarket",
                                      },
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.defaultSetting
                                          .isSelectItemTypeAfterMarket
                                      )
                                        ? _vm._i(
                                            _vm.defaultSetting
                                              .isSelectItemTypeAfterMarket,
                                            null
                                          ) > -1
                                        : _vm.defaultSetting
                                            .isSelectItemTypeAfterMarket,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a =
                                            _vm.defaultSetting
                                              .isSelectItemTypeAfterMarket,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.defaultSetting,
                                                "isSelectItemTypeAfterMarket",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.defaultSetting,
                                                "isSelectItemTypeAfterMarket",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.defaultSetting,
                                            "isSelectItemTypeAfterMarket",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _c("div", { staticClass: "state" }, [
                                    _c("i", {
                                      staticClass: "icon mdi mdi-check",
                                    }),
                                    _c("label", [_vm._v("Aftermarket")]),
                                  ]),
                                ]
                              ),
                            ]),
                            _c("div", { staticClass: "field" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pretty p-icon p-curve p-smooth p-bigger",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.defaultSetting
                                            .isSelectItemTypeUsed,
                                        expression:
                                          "defaultSetting.isSelectItemTypeUsed",
                                      },
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.defaultSetting.isSelectItemTypeUsed
                                      )
                                        ? _vm._i(
                                            _vm.defaultSetting
                                              .isSelectItemTypeUsed,
                                            null
                                          ) > -1
                                        : _vm.defaultSetting
                                            .isSelectItemTypeUsed,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a =
                                            _vm.defaultSetting
                                              .isSelectItemTypeUsed,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.defaultSetting,
                                                "isSelectItemTypeUsed",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.defaultSetting,
                                                "isSelectItemTypeUsed",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.defaultSetting,
                                            "isSelectItemTypeUsed",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _c("div", { staticClass: "state" }, [
                                    _c("i", {
                                      staticClass: "icon mdi mdi-check",
                                    }),
                                    _c("label", [_vm._v("Used")]),
                                  ]),
                                ]
                              ),
                            ]),
                            _c("div", { staticClass: "field" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pretty p-icon p-curve p-smooth p-bigger",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.defaultSetting
                                            .isSelectItemTypeReconditioned,
                                        expression:
                                          "defaultSetting.isSelectItemTypeReconditioned",
                                      },
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.defaultSetting
                                          .isSelectItemTypeReconditioned
                                      )
                                        ? _vm._i(
                                            _vm.defaultSetting
                                              .isSelectItemTypeReconditioned,
                                            null
                                          ) > -1
                                        : _vm.defaultSetting
                                            .isSelectItemTypeReconditioned,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a =
                                            _vm.defaultSetting
                                              .isSelectItemTypeReconditioned,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.defaultSetting,
                                                "isSelectItemTypeReconditioned",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.defaultSetting,
                                                "isSelectItemTypeReconditioned",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.defaultSetting,
                                            "isSelectItemTypeReconditioned",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _c("div", { staticClass: "state" }, [
                                    _c("i", {
                                      staticClass: "icon mdi mdi-check",
                                    }),
                                    _c("label", [_vm._v("Reconditioned")]),
                                  ]),
                                ]
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "is-divider" }),
                        ]),
                        _c("div", { staticClass: "field" }, [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("Select Default Timeframe"),
                          ]),
                          _c("div", { staticClass: "field-body" }, [
                            _c("div", { staticClass: "field" }, [
                              _c("div", [
                                _c("label", { staticClass: "mr-2" }, [
                                  _vm._v(
                                    "Your default timeframe to receive quote is: "
                                  ),
                                ]),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.defaultSetting.defaultTimeFrame,
                                        expression:
                                          "defaultSetting.defaultTimeFrame",
                                      },
                                    ],
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          _vm.defaultSetting,
                                          "defaultTimeFrame",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                    },
                                  },
                                  _vm._l(
                                    _vm.defaultTimeFrames,
                                    function (timeFrame, index) {
                                      return _c(
                                        "option",
                                        {
                                          key: index,
                                          domProps: { value: timeFrame },
                                        },
                                        [_vm._v(" " + _vm._s(timeFrame) + " ")]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]),
                            ]),
                          ]),
                          _c("div", { staticClass: "is-divider" }),
                        ]),
                        _c("div", { staticClass: "field" }, [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("Select Default Notifications"),
                          ]),
                          _c("div", { staticClass: "field-body" }, [
                            _c("div", { staticClass: "field" }, [
                              _c("label", { staticClass: "mr-2" }, [
                                _vm._v("Select User to be notified: "),
                              ]),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.defaultSetting.userToBeNotified,
                                      expression:
                                        "defaultSetting.userToBeNotified",
                                    },
                                  ],
                                  staticClass: "select",
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.defaultSetting,
                                        "userToBeNotified",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                _vm._l(_vm.users, function (userName, index) {
                                  return _c(
                                    "option",
                                    {
                                      key: index,
                                      domProps: { value: userName },
                                    },
                                    [_vm._v(" " + _vm._s(userName) + " ")]
                                  )
                                }),
                                0
                              ),
                            ]),
                            _c("div", { staticClass: "field" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pretty p-icon p-curve p-smooth p-bigger",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.defaultSetting.isSmsNotifications,
                                        expression:
                                          "defaultSetting.isSmsNotifications",
                                      },
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.defaultSetting.isSmsNotifications
                                      )
                                        ? _vm._i(
                                            _vm.defaultSetting
                                              .isSmsNotifications,
                                            null
                                          ) > -1
                                        : _vm.defaultSetting.isSmsNotifications,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a =
                                            _vm.defaultSetting
                                              .isSmsNotifications,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.defaultSetting,
                                                "isSmsNotifications",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.defaultSetting,
                                                "isSmsNotifications",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.defaultSetting,
                                            "isSmsNotifications",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _c("div", { staticClass: "state" }, [
                                    _c("i", {
                                      staticClass: "icon mdi mdi-check",
                                    }),
                                    _c("label", [
                                      _vm._v("Receive SMS Notifications"),
                                    ]),
                                  ]),
                                ]
                              ),
                            ]),
                            _c("div", { staticClass: "field" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pretty p-icon p-curve p-smooth p-bigger",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.defaultSetting
                                            .isEmailNotifications,
                                        expression:
                                          "defaultSetting.isEmailNotifications",
                                      },
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.defaultSetting.isEmailNotifications
                                      )
                                        ? _vm._i(
                                            _vm.defaultSetting
                                              .isEmailNotifications,
                                            null
                                          ) > -1
                                        : _vm.defaultSetting
                                            .isEmailNotifications,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a =
                                            _vm.defaultSetting
                                              .isEmailNotifications,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.defaultSetting,
                                                "isEmailNotifications",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.defaultSetting,
                                                "isEmailNotifications",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.defaultSetting,
                                            "isEmailNotifications",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _c("div", { staticClass: "state" }, [
                                    _c("i", {
                                      staticClass: "icon mdi mdi-check",
                                    }),
                                    _c("label", [
                                      _vm._v("Receive Email Notifications"),
                                    ]),
                                  ]),
                                ]
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "is-divider" }),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c(
            "footer",
            {
              staticClass: "modal-card-foot",
              style: `justify-content: flex-${_vm.buttonLocation}`,
            },
            [
              _c(
                "button",
                {
                  staticClass: "button is-primary",
                  attrs: { "data-tooltip": "Close" },
                  on: {
                    click: function ($event) {
                      return _vm.Save()
                    },
                  },
                },
                [_vm._v("Save")]
              ),
              _c(
                "button",
                {
                  staticClass: "button tooltip is-tooltip-topright",
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }